import { gsap } from 'gsap'

gsap.registerPlugin()

class CartDetails extends HTMLElement {
  constructor() {
    super()

    const cartDetail = this

    const init = () => {
      handleCartDetail()
    }

    const handleCartDetail = () => {
      const toggle = cartDetail.querySelector('.details__summary')
      const content = cartDetail.querySelector('.details__content')
      const elementHeight = cartDetail.querySelector('.content__inner').clientHeight

      if (!toggle) return false

      toggle.addEventListener('click', () => {
        if (toggle.classList.contains('js-open')) {
          toggle.classList.remove('js-open')
          gsap.to(content, { height: 0, duration: 0.3 })
        } else {
          toggle.classList.add('js-open')
          gsap.to(content, { height: elementHeight, duration: 0.3 })
        }
      })
    }

    init()
  }
}

// Check if element is defined, if not define it..
// eslint-disable-next-line no-undefined
if (customElements.get('cart-detail') === undefined) {
  customElements.define('cart-detail', CartDetails)
}
